import { IS_LOADING, ERROR } from "../../constants";

export { IS_LOADING, ERROR }

export const SET_RESULT_SEARCH_QUOTE = "SET_RESULT_SEARCH_QUOTE"
export const SET_CURRENT_QUOTE = "SET_CURRENT_QUOTE";

export const SET_FILTERED_AND_SORTED_QUOTES = "SET_FILTERED_AND_SORTED_QUOTES";
export const SET_ALL_QUOTES = "SET_ALL_QUOTES";

export const SET_SELECTED_TYPE = "SET_QUOTE_SELECTED_TYPE";
export const SET_SELECTED_STATE = "SET_QUOTE_SELECTED_STATE";
export const SET_START_DATE = "SET_QUOTE_START_DATE";
export const SET_END_DATE = "SET_QUOTE_END_DATE";
export const SET_DISPLAY_AS_LIST = "SET_DISPLAY_AS_LIST";

export const QUOTE_TYPE = "Quote";
export const CONTRACT_TYPE = "Contrat";

export const QUOTE = "QUOTE";

export const NB_MAX_QUOTES_TO_DISPLAY = 3;